module.exports = __webpack_public_path__ + "static/img/2.bee9f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/2.png
// module id = Pgf9
// module chunks = 1